<template>
    <div class="eos-report__revenue-labour-history">
       <div class="eos-report__revenue-labour-history--date">
            <el-date-picker
                v-model="date"
                @change="handleDateChange"
                type="date"
                placeholder="Pick a day"
                :picker-options="pickerOptions">
            </el-date-picker>
       </div>

       <div v-if="tableData.length === 0" style="text-align: center; padding: 40px; color: #909399; font-size: 14px;">
           No EOS data available
       </div>
    
       <el-collapse v-else v-model="activeNames">
            <el-collapse-item v-for="(item, i) in tableData" :key="`eos-${i}`" :title="item.date" :name="item.date">
               <div class="custom-table table-wrp">
                <el-table
                    :data="item.children"
                    style="width: 100%">
                        <el-table-column
                            prop="name"
                            label="">
                        </el-table-column>
                        <el-table-column
                            v-for="(shift, key) in uniqueShifts"
                            :key="key"
                            :prop="key"
                            :label="shift"
                            width="350">
                            <template #default="scope">
                                {{ scope.row[key] }}
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </el-collapse-item>

        </el-collapse>
    </div>
</template>

<script>
import api from '../../api/api'

export default {
    data() {
        return {
            date: null,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            activeNames: "12 June 2025 Thurs",
            uniqueShifts: {},
            tableData: []
        }
    },
    async mounted() {
        await this.fetchEosDailyReport()
    },
    methods: {
        async fetchEosShifts(date) {
            const res = await api.getEosShifts(date)
            return res;
        },
        handleDateChange(date) {
            if (date) {
                const formattedDate = this.formatDate(date)
                this.fetchEosDailyReportByDate(formattedDate)
            } else {
                this.fetchEosDailyReport()
            }
        },
        formatDate(date) {
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },
        async fetchEosDailyReport() {
            try {
                const res = await api.fetchEosDailyReport()
                if (res.length > 0) {
                    this.getEosDailyReportData(res)
                }
            } catch (error) {
                this.tableData = [];
            }
           
        },

        async fetchEosDailyReportByDate(date) {
            try {
                const res = await api.fetchEosDailyReportByDate(date)
                if (res) {
                    this.getEosDailyReportData(res)
                }
            } catch (error) {
                this.tableData = [];

            }
           
        },

        async getEosDailyReportData(res) {
            // Merge duplicate eosDate entries
            const mergedData = {}
            res.forEach(item => {
                if (!mergedData[item.eosDate]) {
                    mergedData[item.eosDate] = {
                        eosDate: item.eosDate,
                        eosDetails: []
                    }
                }
                mergedData[item.eosDate].eosDetails.push(...item.eosDetails)
            })

            // Sort by date descending
            const mergedArray = Object.values(mergedData).sort((a, b) => {
                return new Date(b.eosDate) - new Date(a.eosDate)
            })

            const uniqueShifts = await this.extractUniqueShiftsSorted(mergedArray)
            this.uniqueShifts = uniqueShifts
            this.tableData = mergedArray.map(item => {
                console.log('item', item)

                // Group eosDetails by question
                const groupedByQuestion = {}
                item.eosDetails.forEach(detail => {
                    if (!groupedByQuestion[detail.question]) {
                        groupedByQuestion[detail.question] = {
                            name: detail.question,
                            ...Object.keys(uniqueShifts).reduce((acc, shift) => {
                                acc[shift] =  ''
                                return acc
                            }, {})
                        }
                    }
                    // Add the answer for this shift
                    groupedByQuestion[detail.question][detail.shiftDetail.shift] = detail.shiftDetail.answer
                })

                return {
                    date: this.formatDisplayDate(item.eosDate),
                    children: Object.values(groupedByQuestion)
                }
            })
        },
        formatDisplayDate(dateString) {
            const date = new Date(dateString)
            const day = date.getDate()
            const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                               'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
            const month = monthNames[date.getMonth()]
            const year = date.getFullYear()
            const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat']
            const dayName = dayNames[date.getDay()]

            return `${day} ${month} ${year} ${dayName}`
        },
        /**
         * Extracts unique shift values from EOS data
         * @param {Array} eosData - Array of EOS objects containing eosDate and eosDetails
         * @returns {Object} Object with unique shift values as keys and null as values
         */
        async extractUniqueShifts(eosData) {
            // Initialize empty object for unique shifts
            const uniqueShifts = {};
            
            // Validate input
            if (!Array.isArray(eosData) && eosData.length > 0) {
                throw new Error('Input must be an array of EOS data');
            }

            const shifts = await this.fetchEosShifts(eosData[0].eosDate)
            
            // Iterate through each EOS entry
            eosData.forEach((entry, index) => {
                // Check if entry has eosDetails
                if (!entry.eosDetails || !Array.isArray(entry.eosDetails)) {
                    console.warn(`Entry at index ${index} missing or invalid eosDetails`);
                    return;
                }
                
                // Process each detail in the entry
                    entry.eosDetails.forEach((detail) => {
                    // Check if detail has shiftDetail with shift property
                    if (detail.shiftDetail && detail.shiftDetail.shift) {
                        const shiftValue = detail.shiftDetail.shift;
                        
                        // Add shift to unique shifts object if not already present
                        if (!(shiftValue in uniqueShifts)) {
                            uniqueShifts[shiftValue] = shifts.find(item => item.sequence == shiftValue).name || '';
                        }
                    }
                });
            });
        
            return uniqueShifts;
        },

        /**
         * Alternative version that sorts the shift keys numerically
         * @param {Array} eosData - Array of EOS objects containing eosDate and eosDetails
         * @returns {Object} Object with unique shift values as keys (sorted) and null as values
         */
        async extractUniqueShiftsSorted(eosData) {
            const uniqueShifts = await this.extractUniqueShifts(eosData);
            // Sort keys and rebuild object
            const sortedShifts = {};
            Object.keys(uniqueShifts)
                .sort((a, b) => {
                // Try to sort numerically if possible
                    const numA = parseInt(a);
                    const numB = parseInt(b);
                    if (!isNaN(numA) && !isNaN(numB)) {
                        return numA - numB;
                    }
                    // Fallback to string comparison
                    return a.localeCompare(b);
                })
                .forEach(key => {
                sortedShifts[key] = uniqueShifts[key] || null;
            });
        
            return sortedShifts;
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/eos/eosDailyReport.vue